// extracted by css-extract-rspack-plugin
export default {"overlay":"fSw1_BLsOtgaag6l","container":"T2i5_EJafmQh0r7M","shimmer":"m_rjPTZyg8oxtCcS"};